module.exports = __webpack_public_path__ + "static/img/openrecord.5a6c8ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/gongzonghao/openrecord.jpg
// module id = 9prA
// module chunks = 0